import { Routes } from '@angular/router';
import { LaunchDarklyTenantGuard , AmbassadorAuthorizationRoute } from 'remarketing-angular-library';
import { AuthorizedAmbassadorsComponent } from './components/authorized-ambassadors/authorized-ambassadors.component';
import { AvailableAmbassadorsComponent } from './components/available-ambassadors/available-ambassadors.component';
import { AgreementsGuard, GUARDS } from 'smartauction-frontend-micro-library';

export const ambassadorAuthorizationRoutes: Routes = [
  {
    path: 'ambassador-authorization',
    loadComponent: () => import('./components/ambassador-authorization/ambassador-authorization.component').then(c => c.AmbassadorAuthorizationComponent),
    canActivate: [
      LaunchDarklyTenantGuard,
      AgreementsGuard
    ],
    data: {
      flag: 'menu-sell-ambassadorAuthorizationVariation',
      guards: [
        GUARDS.TermsOfUseGuard,
        GUARDS.PrivacyPolicyGuard
      ]
    },
    children: [
      {
        path: AmbassadorAuthorizationRoute.AUTHORIZED,
        component: AuthorizedAmbassadorsComponent
      },
      {
        path: AmbassadorAuthorizationRoute.AVAILABLE,
        component: AvailableAmbassadorsComponent
      },
      {
        path: '',
        redirectTo: AmbassadorAuthorizationRoute.AUTHORIZED,
        pathMatch: 'full'
      }
    ]
  }
];

